import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// Font Awesomeです
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//firebaseをimport
import { initializeApp } from "firebase/app";
// firebaseの設定
const firebaseConfig = {
    apiKey: "AIzaSyDo8prcfI7JPo48_YIXGOW9LIYmyo9Ib20",
    authDomain: "task-app-8fe21.firebaseapp.com",
    projectId: "task-app-8fe21",
    storageBucket: "task-app-8fe21.appspot.com",
    messagingSenderId: "1095676826444",
    appId: "1:1095676826444:web:aa21171599d5853a9875e9"
  };

// firebaseを初期化
initializeApp(firebaseConfig);
library.add(fas, far)

createApp(App).use(store).use(router).component('fa', FontAwesomeIcon).mount('#app')
